import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../lib/api';
import PostCard from '../components/post/PostCard';
import { Skeleton } from '../components/ui/skeleton';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PostDetailPage() {
  const { postId } = useParams();
  const { user } = useAuth();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await api.get(`/posts/${postId}`);
        setPost(response.data);
      } catch (error) {
        console.error('Error fetching post:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPost();
  }, [postId]);

  const handlePostUpdate = (postId, updates) => {
    setPost(prev => ({ ...prev, ...updates }));
  };

  if (loading) {
    return (
      <div className="mg-page max-w-2xl py-6" data-testid="post-detail-page">
        <Skeleton className="h-8 w-24 mb-6" />
        <div className="glass-card p-4 space-y-4">
          <div className="flex items-center gap-3">
            <Skeleton className="w-10 h-10 rounded-full" />
            <div className="space-y-2">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-3 w-16" />
            </div>
          </div>
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-64 w-full rounded-xl" />
        </div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="mg-page max-w-2xl py-6 text-center" data-testid="post-detail-page">
        <h2 className="font-heading text-xl font-bold mb-2">Post not found</h2>
        <p className="text-muted-foreground mb-4">This post may have been deleted or doesn't exist.</p>
        <Link to="/home">
          <Button variant="outline" className="rounded-full">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="mg-page max-w-2xl py-4 sm:py-6" data-testid="post-detail-page">
      {/* Back lives in the shell top bar (history-aware, falls back to the Hearth) */}

      <PostCard 
        post={post} 
        onUpdate={handlePostUpdate}
        showFullContent
        showComments
      />
    </div>
  );
}
